import { useContext } from "react";
import { ActivitiesContext } from "../context/activities-context";

export const Loading = () => {
	const { dictionaryWords } = useContext(ActivitiesContext);

	return (
		<>
			{dictionaryWords.loading && (
				<div className="status loading">
					<i className="loader"></i>
					<h1>{dictionaryWords.loading}</h1>
				</div>
			)}
		</>
	);
};

export default Loading

